// @ts-nocheck
import { Ref, useCallback, useEffect, useRef, useState } from 'react';

import { LoadingOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import {
  message,
  Spin,
  Modal as ModalAntD,
  Input,
  Result,
  Select as SelectAntD,
  Empty,
} from 'antd';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { T, TF } from 'react-translator-component';

import { normalizeTransactionsResponse } from './normalizeTransactions';
import * as S from './styled';

import closeIcon from '../../../assets/small-close-button.png';
import { resendNFE } from '../../../hooks/nfe';
import { getOcppTags } from '../../../hooks/ocpptags';
import { createXlsxTransactionReport } from '../../../hooks/reports';
import {
  getTransactions,
  patchConfirmPayments,
} from '../../../hooks/transactions';
import { setSearchTransaction } from '../../../redux/actions/searchTransaction';
import {
  messageForStatus,
  unwrapOrToast,
} from '../../../services/unwrapResult';
import { hasFinancialIndicators } from '../../../utils/hasFinancialIndicators/hasFinancialIndicators';
import { isMonetizationProUser } from '../../../utils/isMonetizationProUser/isMonetizationProUser';
import { isProUser } from '../../../utils/isProUser/isProUser';
import { isTerpelTenant } from '../../../utils/isTerpelTenant/isTerpelTenant';
import { isTransactionOptionsDisabled } from '../../../utils/isTransactionOptionsDisabled/isTransactionOptionsDisabled';
import { modalErrorReport } from '../../../utils/modalErrorReport/modalErrorReport';
import { parserStationsForSelect } from '../../../utils/normalizers/IndicatorsPage';
import { COLORS } from '../../../utils/theme/colors';
import InvoiceIcon from '../../atoms/icons/InvoiceIcon';
import RangePickerCustom from '../../atoms/LegacyRangePickerCustom';
import { Select } from '../../organisms/Select';
import { TransactionsTable } from '../../organisms/TransactionsTable/TransactionsTable';

export interface ResendNFEModalProps {
  visible: boolean;
  transactionPk: number;
}

const antLoadingIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const Modal: any = ModalAntD;
const { confirm } = ModalAntD;
const { Search } = Input;

const START = moment(
  new Date(moment().subtract(2, 'days') as any).setHours(0, 0, 0),
).format('YYYY-MM-DD HH:mm:ss');

const END = moment(new Date(moment() as any).setHours(23, 59, 59)).format(
  'YYYY-MM-DD HH:mm:ss',
);

const RANGE_LIMIT_DAYS = 365;
const PAGE_SIZE = 10;
const SEARCH_DEBOUNCE_MS = 400;

const TransactionList = () => {
  const [transactionDataList, setTransactionDataList] = useState({
    error: null,
    list: [],
  });
  const [, setOcppTagDataList] = useState<any>({
    error: null,
    ocppTagList: [],
  });
  const [stationDataList, setStationDataList] = useState<any>({
    error: null,
    chargePointList: [],
  });
  const [ocppTagInputValue, setOcppTagInputValue] = useState('');
  const [stationInputValue, setStationInputValue] = useState('');
  const [paymentStatusInputValue, setPaymentStatusInputValue] = useState('');
  const [fromDateInputValue, setFromDateInputValue] = useState(START);
  const [toDateInputValue, setToDateInputValue] = useState(END);
  const [loading, setLoading] = useState(true);
  const [isExcelLoading, setIsExcelLoading] = useState(false);
  const [isExcelVoucherLoading, setIsExcelVoucherLoading] = useState(false);
  const [selectMode, setSelectMode] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [headerFilter, setHeaderFilter] = useState([]);
  const [count, setCount] = useState(0);
  const [dates, setDates] = useState<any>([
    moment(fromDateInputValue),
    moment(toDateInputValue),
  ]);
  const [value, setValue] = useState<any>([
    moment(fromDateInputValue),
    moment(toDateInputValue),
  ]);
  const [showResendNFEModal, setShowResendNFEModal] =
    useState<ResendNFEModalProps>({
      visible: false,
      transactionPk: 0,
    });
  const [loadingResendNFE, setLoadingResendNFE] = useState(false);

  const [paginationData, setpaginationData] = useState([]);
  const childRef: Ref<any> = useRef();
  const paginate = () => childRef?.current?.paginate();
  const routes = useSelector((state: any) => state.user.routes);

  const dispatch = useDispatch();
  const searchTransaction: any = useSelector(
    (state: any) => state.searchTransaction.searchTransaction,
  );

  const [debouncedSearch, setDebouncedSearch] = useState(
    searchTransaction ?? '',
  );
  const [searchNonce, setSearchNonce] = useState(0);
  const searchDebounceTimer = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const requestIdRef = useRef(0);

  const isSearchPending = (searchTransaction ?? '') !== debouncedSearch;

  const localUser = localStorage.getItem('auth-user');
  const user = localUser !== null ? JSON.parse(localUser) : { id: '' };
  const userId = user.id;

  const isVehicle = !!(
    routes && routes.find(({ path }) => path === '/vehicle/create')
  );

  const chargePointList = useSelector(
    (state: any) => state.chargePoints.chargePoints.chargePointList,
  );
  const ocppTagList = useSelector(
    (state: any) => state.ocppTags.ocppTags.ocppTagList,
  );

  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);

  const fetchOcppTags = async (searchInput = '', page = 1, size = 10) => {
    setFetching(true);

    const response = await getOcppTags(searchInput, page, size);

    if (response?.ocppTagList?.length) {
      setOptions(
        response.ocppTagList.map((tag) => ({
          label: `${tag.userName ? `${tag.userName} - ` : ''}${
            tag.userEmail ? `${tag.userEmail} - ` : ''
          }${tag.idTag}`,
          value: `${tag.userName ? `${tag.userName} - ` : ''}${
            tag.userEmail ? `${tag.userEmail} - ` : ''
          }${tag.idTag}`,
        })),
      );
    }

    setFetching(false);
  };

  useEffect(() => {
    (async () => {
      await fetchOcppTags();
    })();
  }, []);

  const handleTransactions = useCallback(
    async (search) => {
      const transactionForm = {
        chargeBoxPk: stationInputValue,
        userOcppTag: ocppTagInputValue,
        fromDate: fromDateInputValue,
        toDate: toDateInputValue,
        paymentStatus: paymentStatusInputValue,
        searchInput: search,
        headerOrderList: headerFilter
          .filter((h: any) => h.value != 'null')
          .map((h: any) => h.key + ':' + h.value)
          .join(';'),
        page: currentPage,
        size: PAGE_SIZE,
      };

      const requestId = ++requestIdRef.current;

      try {
        setLoading(true);
        const response = await getTransactions(transactionForm);

        if (requestId !== requestIdRef.current) {
          return;
        }

        const {
          list,
          count: total,
          degraded,
        } = normalizeTransactionsResponse(
          unwrapOrToast(response, { list: [], count: 0 }),
        );

        // Sobra para o `degraded` só o que o funil deixou passar como sucesso
        // (502/504 com body HTML, 204/202 sem data), sem status para consultar.
        if (degraded) {
          message.error(messageForStatus(null));
        }

        let transactionList = list;

        if (!hasFinancialIndicators()) {
          transactionList = transactionList.map((transaction) => {
            delete transaction.incomeHumanReadable;

            return transaction;
          });
        }

        if (
          !isMonetizationProUser() &&
          !isTerpelTenant() &&
          hasFinancialIndicators()
        ) {
          transactionList = transactionList.map((transaction) => {
            delete transaction.income;
            delete transaction.incomeHumanReadable;
            delete transaction.transactionAmount;
            delete transaction.transactionAmountHumanReadable;
            return transaction;
          });
        }

        if (transactionList.length >= 10000) {
          setTimeout(() => {
            message.warning(T('The query is limited to 10,000 transactions!'));
          }, 3000);
        }
        setTransactionDataList({ error: null, list: transactionList });
        setpaginationData(transactionList);
        paginate();
        setCount(total);
      } catch (error) {
        if (requestId !== requestIdRef.current) {
          return;
        }
        console.error('Failed to load transactions:', error);
        message.error(messageForStatus(null));
      } finally {
        if (requestId === requestIdRef.current) {
          setLoading(false);
        }
      }
    },
    [
      currentPage,
      fromDateInputValue,
      headerFilter,
      ocppTagInputValue,
      paymentStatusInputValue,
      stationInputValue,
      toDateInputValue,
    ],
  );

  useEffect(() => {
    if (searchDebounceTimer.current) {
      clearTimeout(searchDebounceTimer.current);
    }

    searchDebounceTimer.current = setTimeout(() => {
      setDebouncedSearch(searchTransaction ?? '');
    }, SEARCH_DEBOUNCE_MS);

    return () => {
      if (searchDebounceTimer.current) {
        clearTimeout(searchDebounceTimer.current);
      }
    };
  }, [searchTransaction]);

  useEffect(() => {
    handleTransactions(debouncedSearch);
  }, [
    ocppTagInputValue,
    stationInputValue,
    fromDateInputValue,
    toDateInputValue,
    userId,
    paymentStatusInputValue,
    currentPage,
    headerFilter,
    debouncedSearch,
    searchNonce,
    handleTransactions,
  ]);

  useEffect(() => {
    setStationDataList(chargePointList);
    setOcppTagDataList(ocppTagList);
  }, [chargePointList, ocppTagList]);

  const onSearch = (value) => {
    if (searchDebounceTimer.current) {
      clearTimeout(searchDebounceTimer.current);
    }
    setDebouncedSearch(value);
    setSearchNonce((nonce) => nonce + 1);
  };

  const handleSearch = (e) => {
    dispatch(setSearchTransaction(e));
  };

  const notifyReportLimitExceeded = (report: any) => {
    if (!report?.data?.error?.startsWith('TRANSACTION_EXPORT_LIMIT_EXCEEDED')) {
      return false;
    }
    const limit = Number(report.data.error.split(':')[1] || 0).toLocaleString(
      'pt-BR',
    );
    message.warning(
      TF(
        'The report exceeds the allowed limit of {0} transactions. Adjust the filters and try again.',
        limit,
      ),
    );
    return true;
  };

  const handleDownloadExcelVoucher = async () => {
    setIsExcelVoucherLoading(true);
    const transactionForm = {
      chargeBoxPk: stationInputValue,
      userOcppTag: ocppTagInputValue,
      fromDate: fromDateInputValue,
      toDate: toDateInputValue,
      paymentStatus: paymentStatusInputValue,
      searchInput: searchTransaction,
      isVoucher100: true,
      isVehicle,
    };
    const xlsxTransactionReport = await createXlsxTransactionReport(
      transactionForm,
    );

    if (
      !notifyReportLimitExceeded(xlsxTransactionReport) &&
      xlsxTransactionReport.type === 'error'
    ) {
      if (xlsxTransactionReport.status === 403) {
        modalErrorReport();
      } else {
        message.error(T('Unable to download the .xlsx file.'));
      }
    }
    setIsExcelVoucherLoading(false);
  };

  const handleDownloadExcel = async () => {
    setIsExcelLoading(true);
    const transactionForm = {
      chargeBoxPk: stationInputValue,
      userOcppTag: ocppTagInputValue,
      fromDate: fromDateInputValue,
      toDate: toDateInputValue,
      paymentStatus: paymentStatusInputValue,
      searchInput: searchTransaction,
      isVoucher100: false,
      isVehicle,
    };
    const xlsxTransactionReport = await createXlsxTransactionReport(
      transactionForm,
    );

    if (
      !notifyReportLimitExceeded(xlsxTransactionReport) &&
      xlsxTransactionReport.type === 'error'
    ) {
      if (xlsxTransactionReport.status === 403) {
        modalErrorReport();
      } else {
        message.error(T('Unable to download the .xlsx file.'));
      }
    }
    setIsExcelLoading(false);
  };

  const handleOnSelectMode = () => {
    if (selectMode) {
      setSelectMode(false);
      setCheckedList([]);
    } else {
      setSelectMode(true);
    }
  };

  const handleTransactionsSelected = () => {
    if (checkedList.length == 0) {
      message.error(
        T('Must select at least one transaction to perform action!'),
      );
      return;
    }
    confirm({
      title: T('Confirm payment?'),
      content:
        T('The following transactions will have payment confirmed: ') +
        checkedList.join(', '),
      icon: <ExclamationCircleOutlined />,
      okText: T('Yes'),
      okType: 'danger',
      cancelText: T('Cancel'),
      async onOk() {
        const result = await patchConfirmPayments({
          transaction_pks: checkedList.map(Number),
          paid_timestamp: new Date(),
          payment_type: 'MANUAL_DASHBOARD',
        });
        if (result.status === 200) {
          message.success(T('Payments successfully confirmed!'));
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          message.error(T('Error when trying to confirm payments!'));
        }
      },
      onCancel() {},
    });
  };

  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate =
      dates?.[0] && current.diff(dates?.[0], 'days') >= RANGE_LIMIT_DAYS;
    const tooEarly =
      dates?.[1] && dates?.[1].diff(current, 'days') >= RANGE_LIMIT_DAYS;
    return !!tooEarly || !!tooLate || current.valueOf() > Date.now();
  };
  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  const handleResendNFE = async () => {
    setLoadingResendNFE(true);

    const tryResendNFE = await resendNFE(showResendNFEModal.transactionPk);

    setLoadingResendNFE(false);

    if (tryResendNFE.type === 'error') {
      message.error(T('Error resending invoice!'));
    } else if (tryResendNFE.type === 'success') {
      message.success(T('Invoice resent successfully!'));

      handleTransactions(searchTransaction);
    }

    setShowResendNFEModal({ visible: false, transactionPk: 0 });
  };

  return (
    <>
      <Modal
        visible={showResendNFEModal.visible}
        closable={false}
        footer={null}
      >
        <Result
          icon={<InvoiceIcon fill={COLORS.red} size={64} />}
          title={T(
            'Oops! It seems that something went wrong when issuing the invoice. Do you want to try again?',
          )}
          extra={[
            <S.Button
              key='default'
              size='large'
              onClick={() =>
                setShowResendNFEModal({ visible: false, transactionPk: 0 })
              }
            >
              Sair
            </S.Button>,
            <S.Button
              type='primary'
              key='primary'
              size='large'
              onClick={handleResendNFE}
              loading={loadingResendNFE}
            >
              Tentar novamente
            </S.Button>,
          ]}
        />
      </Modal>

      <S.Div>
        <h1 className='page_title'>{T('Transactions')}</h1>
        <div className='selects_bar'>
          <SelectAntD
            title={
              isTransactionOptionsDisabled()
                ? 'Campo temporariamente desativado'
                : undefined
            }
            disabled={isTransactionOptionsDisabled()}
            showSearch
            placeholder='Pesquisar Tag'
            size='large'
            options={options}
            onSearch={async (search) => {
              if (search) {
                await fetchOcppTags(search, 1, 10);
              }
            }}
            onChange={(value: any) => {
              if (value) {
                const idTag = value.split(' - ').pop();
                setOcppTagInputValue(idTag);
              }
            }}
            style={{ width: 400 }}
            notFoundContent={
              fetching ? (
                <Spin size='small' />
              ) : (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description='Não há dados'
                  style={{ margin: 'auto', width: '100%' }}
                />
              )
            }
          />

          <Select
            value={stationInputValue}
            options={
              stationDataList?.length
                ? parserStationsForSelect(stationDataList)
                : []
            }
            action={(value) => setStationInputValue(value)}
            ordered
          />
          {(isMonetizationProUser() || isTerpelTenant()) &&
            hasFinancialIndicators() && (
              <Select
                value={paymentStatusInputValue}
                options={[
                  { value: '', label: T('All Revenue Status'), id: 0 },
                  { value: 'PAID', label: 'Receita Paga', id: 1 },
                  { value: 'UNPAID', label: 'Receita Não Paga', id: 2 },
                  { value: 'PRICELESS', label: 'Sem cobrança', id: 3 },
                ]}
                action={(value) => setPaymentStatusInputValue(value)}
              />
            )}
          <RangePickerCustom
            className='range_picker'
            format='DD/MM/YYYY'
            value={dates || value}
            disabledDate={disabledDate}
            onCalendarChange={(val) => setDates(val)}
            onChange={(val) => {
              setFromDateInputValue(
                val?.length && val[0]
                  ? moment(new Date(val[0]).setHours(0, 0, 0)).format(
                      'YYYY-MM-DD HH:mm:ss',
                    )
                  : START,
              );
              setToDateInputValue(
                val?.length && val[1]
                  ? moment(new Date(val[1]).setHours(23, 59, 59)).format(
                      'YYYY-MM-DD HH:mm:ss',
                    )
                  : END,
              );
              setValue(val);
            }}
            onOpenChange={onOpenChange}
            allowClear={false}
          />
        </div>

        <div className='tools_bar'>
          {isProUser() &&
          routes.find(
            ({ path }) => path === '/transactions/:id/payment/edit',
          ) ? (
            selectMode ? (
              <div className='div_selected'>
                <button
                  className='selected_button cursor'
                  onClick={handleTransactionsSelected}
                >
                  {T('Approve (') + checkedList.length + T(') Transactions')}
                </button>
                <img
                  onClick={() => handleOnSelectMode()}
                  className='close_select_button'
                  src={closeIcon}
                />
              </div>
            ) : (
              <button
                className='action_button cursor'
                onClick={() => handleOnSelectMode()}
              >
                {T('Approve Transactions')}
              </button>
            )
          ) : null}
          {isExcelVoucherLoading ? (
            <div style={{ margin: '8px 6% 0 0' }}>
              <Spin indicator={antLoadingIcon} />
            </div>
          ) : (
            <button
              title={
                isTransactionOptionsDisabled()
                  ? 'Campo temporariamente desativado'
                  : undefined
              }
              className='action_button cursor'
              disabled={isTransactionOptionsDisabled()}
              onClick={() => handleDownloadExcelVoucher()}
            >
              {T('Download Voucher 100%')}
            </button>
          )}

          {isExcelLoading ? (
            <div style={{ margin: '8px 6% 0 0' }}>
              <Spin indicator={antLoadingIcon} />
            </div>
          ) : (
            <button
              title={
                isTransactionOptionsDisabled()
                  ? 'Campo temporariamente desativado'
                  : undefined
              }
              className='action_button cursor'
              disabled={isTransactionOptionsDisabled()}
              onClick={() => handleDownloadExcel()}
            >
              {T('Download Excel')}
            </button>
          )}
          <Search
            placeholder={T('Search by ID or Station Name')}
            enterButton='Search'
            size='middle'
            loading={loading || isSearchPending}
            allowClear
            value={searchTransaction}
            onSearch={onSearch}
            onChange={(e) => handleSearch(e.target.value)}
            className='search'
          />
        </div>
        <TransactionsTable
          transactions={transactionDataList?.list ?? []}
          loading={loading}
          {...{
            paginationData,
            setpaginationData,
            childRef,
            count,
            currentPage,
            setCurrentPage,
            pageSize: PAGE_SIZE,
          }}
          setShowResendNFEModal={setShowResendNFEModal}
          selectMode={selectMode}
          checkedList={checkedList}
          setCheckedList={setCheckedList}
          headerFilter={headerFilter}
          setHeaderFilter={setHeaderFilter}
        />
      </S.Div>
    </>
  );
};

export default TransactionList;
